import { SortTitles } from '@components/SitemapReport/constants'
import type { SortType } from '@components/SitemapReport/types'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { SortButton, SortOptions } from './components'

interface Props {
  onChange: (t: SortType) => void
  value: SortType
}

export const SortSelect: React.FC<Props> = ({ onChange, value }) => {
  const onClick = (path: string[]) => {
    const nextSort = path[0] as SortType

    if (nextSort !== value) {
      sendGtmEvent(GtmTriggerName.REPORT_SORT_CHANGED)
    }

    onChange(nextSort)
  }

  return (
    <DropdownMenu.Root onClick={onClick} content={SortOptions} active={value}>
      <SortButton title={SortTitles[value]} />
    </DropdownMenu.Root>
  )
}
